import * as React from "react";

const String = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M4.975 10.36h2.158l-1.05-3.057H6.06L4.975 10.36zm.175-5.11h1.878l3.115 8.33H8.242l-.63-1.855H4.497l-.654 1.855H2l3.15-8.33zm10.706 5.32c0-.257-.027-.502-.082-.735a1.92 1.92 0 0 0-.257-.618 1.344 1.344 0 0 0-.437-.426 1.214 1.214 0 0 0-.636-.158 1.222 1.222 0 0 0-1.073.584 1.92 1.92 0 0 0-.257.618 3.225 3.225 0 0 0-.082.735c0 .249.028.49.082.723.055.234.14.44.257.619a1.222 1.222 0 0 0 1.073.583c.249 0 .46-.052.636-.158.175-.105.32-.246.437-.425a1.92 1.92 0 0 0 .257-.619c.055-.233.082-.474.082-.723zm-4.422-5.32h1.657v3.033h.023c.202-.31.476-.538.823-.682a2.785 2.785 0 0 1 1.079-.216 2.296 2.296 0 0 1 1.697.758c.237.257.43.586.578.986.148.4.221.877.221 1.43 0 .552-.073 1.028-.221 1.429-.148.4-.34.729-.578.985a2.3 2.3 0 0 1-1.697.759c-.444 0-.84-.07-1.19-.21a1.51 1.51 0 0 1-.794-.712h-.023v.77h-1.575V5.25z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default String;

